import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronsDown } from "@fortawesome/pro-solid-svg-icons/faChevronsDown";
import { faChevronsUp } from "@fortawesome/pro-solid-svg-icons/faChevronsUp";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import { faCircleDashed } from "@fortawesome/pro-solid-svg-icons/faCircleDashed";
import { faDash } from "@fortawesome/pro-solid-svg-icons/faDash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";

import { CompetencyFit } from "@/types/screeners";

export const getCompetencyBadgeWidth = (hasRawScore: boolean) =>
  hasRawScore ? "w-[138px]" : "w-[102px]";

export interface BadgeStyles {
  background: string;
  text: string;
}

export interface IconBadgeStyles extends BadgeStyles {
  icon: ReactNode;
}

type AskedCompetencyFit = Exclude<CompetencyFit, CompetencyFit.NotAsked>;
type CompetencyStylesRecord = Record<AskedCompetencyFit, IconBadgeStyles>;

const OVERALL_FIT_STYLES: CompetencyStylesRecord = {
  [CompetencyFit.VeryHigh]: {
    background: "#B8ECE3",
    text: "#005648",
    icon: <FontAwesomeIcon color="#00806A" icon={faChevronsUp} size="xs" />,
  },
  [CompetencyFit.High]: {
    background: "#C4E8A9",
    text: "#1D5200",
    icon: <FontAwesomeIcon color="#3C8600" icon={faChevronUp} size="xs" />,
  },
  [CompetencyFit.Medium]: {
    background: "#FFF4B2",
    text: "#706000",
    icon: <FontAwesomeIcon color="#8C7400" icon={faDash} size="xs" />,
  },
  [CompetencyFit.Low]: {
    background: "#FFD39F",
    text: "#6C3B00",
    icon: <FontAwesomeIcon color="#B46000" icon={faChevronDown} size="xs" />,
  },
  [CompetencyFit.VeryLow]: {
    background: "#FFC9B3",
    text: "#822716",
    icon: <FontAwesomeIcon color="#E81F00" icon={faChevronsDown} size="xs" />,
  },
  [CompetencyFit.Absent]: {
    background: "#DDDDDD",
    text: "#474747",
    icon: <FontAwesomeIcon color="#666666" icon={faCircleDashed} size="xs" />,
  },
};

const COMPETENCY_STYLES: CompetencyStylesRecord = {
  [CompetencyFit.VeryHigh]: {
    background: "#00806A",
    text: "#00806A",
    icon: <FontAwesomeIcon color="#00806A" icon={faChevronsUp} size="xs" />,
  },
  [CompetencyFit.High]: {
    background: "#3C8600",
    text: "#3C8600",
    icon: <FontAwesomeIcon color="#3C8600" icon={faChevronUp} size="xs" />,
  },
  [CompetencyFit.Medium]: {
    background: "#8C7400",
    text: "#8C7400",
    icon: <FontAwesomeIcon color="#8C7400" icon={faDash} size="xs" />,
  },
  [CompetencyFit.Low]: {
    background: "#B46000",
    text: "#B46000",
    icon: <FontAwesomeIcon color="#B46000" icon={faChevronDown} size="xs" />,
  },
  [CompetencyFit.VeryLow]: {
    background: "#E81F00",
    text: "#E81F00",
    icon: <FontAwesomeIcon color="#E81F00" icon={faChevronsDown} size="xs" />,
  },
  [CompetencyFit.Absent]: {
    background: "#666666",
    text: "#666666",
    icon: <FontAwesomeIcon color="#666666" icon={faCircleDashed} size="xs" />,
  },
};

export const getCompetencyBadgeStyles = (
  score: AskedCompetencyFit,
  isOverallFit = false,
) => (isOverallFit ? OVERALL_FIT_STYLES : COMPETENCY_STYLES)[score];
